
export const addDeletedCoachToDropdown = (coachData, dropdown) => {
    // Selected coach can be logically deleted
    // In that case we need to add him to dropdown
    if (coachData?.id) {
        const coach  = {
            label: `${coachData.firstName} ${coachData.lastName}`,
            value: coachData.id,
        };
        const exists = dropdown.value.some(item => item.value === coach.value);
        if (!exists) {
            dropdown.value.push(coach);
        }
    }
};

export const addDeletedModuleToDropdown = (moduleData, dropdown) => {
    // Selected module can be logically deleted
    // In that case we need to add him to dropdown
    if (moduleData?.id) {
        const module = {
            label: `${moduleData.name}`,
            value: moduleData.id,
        };
        const exists = dropdown.value.some(item => item.value === module.value);
        if (!exists) {
            dropdown.value.push(module);
        }
    }
};

export const truncateText = (text, length) => {
    if (!text || typeof text !== 'string') {
        return ''; // Return an empty string if text is null, undefined, or not a string
    }

    const strippedText = text
        .replace(/<\/?[^>]+(>|$)/g, ' ') // Remove HTML tags
        .replace(/&nbsp;/gi, ' ') // Remove non-breaking space entities
        .replace(/\s+/g, ' ') // Collapse repeated whitespace
        .trim();

    return strippedText.length > length ? strippedText.substring(0, length) + '...' : strippedText;
};